import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { request, gql, Variables } from 'graphql-request';

import { QueryKeys } from 'src/constants/queryKeys';

import { config } from '@app/config';
import { Pair, Position } from '@app/types/pool';

const fetcher = (
  baseUrl: string,
  params: Variables = {
    skip: 0,
    first: 10,
    orderBy: 'created',
    orderDirection: 'desc',
    search: '',
    address: ''
  }
) => {
  return request<{ liquidityPositions: Position[] }>(
    `${baseUrl}`,
    gql`
      query {
        liquidityPositions (
          skip: ${params.skip},
          first: ${params.first},
          where: {
            user: "${params.address}"
          }
        ) {
          id
          pair {
            id
            reserve0
            reserve1
            reserveETH
            reserveUSD
            token0Price
            token1Price
            volumeUSD
            totalSupply
            token0 {
              id
              totalSupply
              symbol
              name
              decimals
              tradeVolumeUSD
              tradeVolume
              totalLiquidity
              txCount
              derivedETH
            }
            token1 {
              id
              totalSupply
              symbol
              name
              decimals
              tradeVolumeUSD
              tradeVolume
              totalLiquidity
              txCount
              derivedETH
            }
          }
          liquidityTokenBalance
        }
      }
    `,
    params
  );
};

export const usePositionsListData = (
  params: Variables = {},
  options: UseQueryOptions<Position[]> = {}
) => {
  return useQuery<Position[]>(
    [QueryKeys.USER_POSITIONS, { params }],
    async () => {
      const response = await fetcher(config.subgraphUrl as string, {
        ...params
      });

      return response.liquidityPositions;
    },
    {
      staleTime: 60000,
      refetchOnWindowFocus: true,
      ...options
    }
  );
};
